import React from 'react';

import TaskDetailsIcon from 'screens/common/taskDetailsIcon';
import styled from 'styled-components';
import { StyledTooltip } from 'styles/common';

export default function DetailIconComponent({ className, tooltipText = '', ...props }) {
  return (
    <StyledTooltip title={tooltipText}>
      <Container className={className}>
        <DetailsIcon taskId={null} showDetails={() => {}} color="primary" {...props} />
      </Container>
    </StyledTooltip>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  visibility: hidden;
`;

const DetailsIcon = styled(TaskDetailsIcon)`
  display: flex;
  padding: 2px;

  padding: 4px;
`;
